import styled from "styled-components";

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const GeneratingImg = styled.img`
  height: 6rem;
  width: 100%;
`;

export const GeneratingTitle = styled.h1`
  margin-top: 5rem;
  font-size: 2rem;
`;
